import { getConfig } from '@monorepo/tools/src/lib/get-config';
import { id } from '@monorepo/tools/src/lib/types/primitives';
import { getManagementApiBaseUrl } from '../../utils/management-api';

export class BidderDomainsEndpoints {
	private rootApi: string;
	private baseUrl: string;
	private crudUrl: string;

	constructor() {
		this.rootApi = getManagementApiBaseUrl();
		this.baseUrl = `${this.rootApi}/bidder`;
		this.crudUrl = `${getConfig().env.sheriffRoot}/adminx-bidder/admin`;
	}

	getCampaignDomainTagCounters() {
		return `${this.crudUrl}/getCampaignDomainTagCounters`;
	}

	getNotWorkingDomainCounters() {
		return `${this.crudUrl}/getNotWorkingDomainCounters`;
	}

	getCampaignTrashDomainCounters() {
		return `${this.crudUrl}/getCampaignTrashDomainCounters`;
	}

	getCampaignDomainStatus() {
		return `${this.crudUrl}/getCampaignDomainStatus`;
	}

	getDomainStatuses() {
		return `${this.crudUrl}/getDomainStatuses`;
	}

	getCampaignConflictData(campaignId: id) {
		return `${this.crudUrl}/getCampaignConflictData?id=${campaignId}`;
	}

	download(pathname: string) {
		return `${this.crudUrl}/${pathname}`;
	}

	downloadCampaignConflictData(id: number, secondId: number) {
		return `${this.crudUrl}/downloadCampaignConflictData?id=${id}&second_id=${secondId}`;
	}

	deleteDomainCampaignCache() {
		return `${this.crudUrl}/deleteDomainCampaignCache`;
	}

	openClosedDomain() {
		return `${this.crudUrl}/openClosedDomain`;
	}
}
